
interface Channel {
    name: string;
    logo: string;
}

const channels = {
    'Antena 1': {
        name: 'Antena 1',
        logo: 'icTvProgrammeAntena1'
    },
    'Digi Sport 1': {
        name: 'Digi Sport 1',
        logo: 'icTvProgrammeDigiSport1'
    },
    'Digi Sport 2': {
        name: 'Digi Sport 2',
        logo: 'icTvProgrammeDigiSport2'
    },
    'Digi Sport 3': {
        name: 'Digi Sport 3',
        logo: 'icTvProgrammeDigiSport3'
    },
    'Digi Sport 4': {
        name: 'Digi Sport 4',
        logo: 'icTvProgrammeDigiSport4'
    },
    'Eurosport 1': {
        name: 'Eurosport 1',
        logo: 'icTvProgrammeEurosport1'
    },
    'Eurosport 2': {
        name: 'Eurosport 2',
        logo: 'icTvProgrammeEurosport2'
    },
    'GSP TV': {
        name: 'GSP TV',
        logo: 'icTvProgrammeGspTv'
    },
    'Look Plus': {
        name: 'Look Plus',
        logo: 'icTvProgrammeLookPlus'
    },
    'Look Sport': {
        name: 'Look Sport',
        logo: 'icTvProgrammeLookSport'
    },
    'Pro TV': {
        name: 'Pro TV',
        logo: 'icTvProgrammeProTv'
    },
    'Sport.Ro': {
        name: 'Sport.Ro',
        logo: 'icTvProgrammeSportRo'
    },
    TVR: {
        name: 'TVR',
        logo: 'icTvProgrammeTvr'
    },
    'TVR 1': {
        name: 'TVR 1',
        logo: 'icTvProgrammeTvr1'
    },
    'TVR 2': {
        name: 'TVR 2',
        logo: 'icTvProgrammeTvr2'
    },
    'TVR 3': {
        name: 'TVR 3',
        logo: 'icTvProgrammeTvr3'
    },
    'Telekom Sport 1': {
        name: 'Telekom Sport 1',
        logo: 'icTvProgrammeTelekomSport1'
    },
    'Telekom Sport 2': {
        name: 'Telekom Sport 2',
        logo: 'icTvProgrammeTelekomSport2'
    },
    'Telekom Sport 3': {
        name: 'Telekom Sport 3',
        logo: 'icTvProgrammeTelekomSport3'
    },
    'Telekom Sport 4': {
        name: 'Telekom Sport 4',
        logo: 'icTvProgrammeTelekomSport4'
    },
    'Telekom Sport 5': {
        name: 'Telekom Sport 5',
        logo: 'icTvProgrammeTelekomSport5'
    },
    'Telekom Sport 6': {
        name: 'Telekom Sport 6',
        logo: 'icTvProgrammeTelekomSport6'
    },
    'RAI 1': {
        name: 'RAI 1',
        logo: 'icTv   ProgrammeRai1'
    },
    'Pro X': {
        name: 'Pro X',
        logo: 'icTvProgrammeProX'
    }
} as Record<string, Channel>;

export function getChannelLogo(name: string): string {
    return channels[name] ? channels[name].logo : 'ic_tv_programme_placeholder';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/data/tvChannels.ts